import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import type CK from '~/types/contentking';

import Copy from '~/components/logic/Copy';
import DestructConfirmationModal from '~/components/app/DestructConfirmationModal';
import LabeledValuesBox from '~/components/patterns/structuredValues/labeledValues/LabeledValuesBox';

import useRemoveAccessToClient from '~/hooks/useRemoveAccessToClient';

import FormError from '~/utilities/FormError';



const messages = defineMessages({
	changeYourMind: {
		id: 'ui.cancelConnectedAccountAccessRequestConfirmation.changeYourMind',
	},
	confirmButton: {
		id: 'ui.cancelConnectedAccountAccessRequestConfirmation.confirmButton',
	},
	labelConnectedAccount: {
		id: 'ui.cancelConnectedAccountAccessRequestConfirmation.labelConnectedAccount',
	},
	title: {
		id: 'ui.cancelConnectedAccountAccessRequestConfirmation.title',
	},
	verb: {
		id: 'ui.cancelConnectedAccountAccessRequestConfirmation.verb',
	},
	warnPermanent: {
		id: 'ui.cancelConnectedAccountAccessRequestConfirmation.warnPermanent',
	},
});



type Props = {
	agencyAccountId: CK.AccountId,
	connectedAccountId: CK.AccountId,
	connectedAccountName: string,
};

const CancelConnectedAccountAccessRequestConfirmationModal: React.FC<Props> = (props) => {
	const {
		agencyAccountId,
		connectedAccountId,
		connectedAccountName,
	} = props;

	const removeAccessToClient = useRemoveAccessToClient();

	const handleRemoval = React.useCallback(
		async () => {
			try {
				await removeAccessToClient({
					agencyId: agencyAccountId,
					clientId: connectedAccountId,
				});
			} catch (error) {
				throw FormError.fromApolloError(error);
			}
		},
		[
			agencyAccountId,
			connectedAccountId,
			removeAccessToClient,
		],
	);

	return (
		<DestructConfirmationModal
			confirmButton={(
				<FormattedMessage {...messages.confirmButton} />
			)}
			onConfirmation={handleRemoval}
			titleAction={(
				<FormattedMessage {...messages.verb} />
			)}
			titleObject={(
				<FormattedMessage {...messages.title} />
			)}
		>
			<Copy {...messages.warnPermanent} />

			<LabeledValuesBox
				items={[
					{
						label: (
							<FormattedMessage {...messages.labelConnectedAccount} />
						),
						value: connectedAccountName,
					},
				]}
			/>

			<span>
				<Copy {...messages.changeYourMind} />
			</span>
		</DestructConfirmationModal>
	);
};



export default CancelConnectedAccountAccessRequestConfirmationModal;
